(ns frontend.ui.page.lp-portal.archive.filters-section.style
  (:require
   [garden.units :refer [px]]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :refer [text-size]]))

(defn container
  []
  ^{:media {{:screen :only :max-width (px 991)}
            {:gap :20px}
            {:screen :only :max-width (px 640)}
            {:flex-flow "column"
             :gap       :16px
             :padding   "24px 0"}}}
  {:display         :flex
   :flex            "0 0 auto"
   :justify-content :space-between
   :padding         "45px 0 30px"
   :gap             :30px
   :align-items     :flex-end})

(defn filters-container
  []
  ^{:media {{:screen :only :max-width (px 899)}
            {}
            {:screen :only :max-width (px 640)}
            {:width       :100%
             :flex-flow   "column"
             :align-items "flex-start"}}}
  {:display     :flex
   :gap         :30px
   :flex        :1
   :max-width   :700px
   :align-items :center})

(defn filter-group-container
  []
  {:width :100%})

(defn align-right
  []
  {:height          "100%"
   :display         "flex"
   :justify-content "flex-end"
   :align-items     "flex-end"})

(defn archive-filters
  []
  {:background (theme/color [:page-bg :bg])
   :border-bottom-width "1px"
   :border-bottom-style "solid"
   :border-bottom-color (theme/color [:general-border :border])
   :padding "30px 12px"})

(defn form-group-label
  []
  {:display        "block"
   :padding-bottom "10px"
   :font-size      "12px"
   :color          (theme/color [:text :primary])
   :letter-spacing "2.2px"
   :font-weight    "bold"
   :text-transform "uppercase"})

(defn dropdown-container
  []
  {:display     :flex
   :flex        :1
   :position    :relative
   :user-select :none})

(defn dropdown
  []
  {:width          :100%
   :padding        "16px 32px 16px 16px"
   :border-width   "1px"
   :border-style   "solid"
   :border-color   (theme/color [:general-border :border])
   :border-radius  :3px
   :appearance     :none
   :text-transform :uppercase
   :font-size      (text-size :xxsmall :size)
   :font-weight    :700
   :letter-spacing :0.2em
   :text-overflow  :ellipsis
   :color          (theme/color [:dropdown :color])})

(defn dropdown-caret
  []
  {:width          :10px
   :position       :absolute
   :right          :21px
   :top            :50%
   :margin-top     :-2.5px
   :pointer-events :none
   :transform      "translateY(-50%)"})

(defn quarter-options
  []
  {:display     :flex
   :height      "50px"
   :gap         :12px
   :user-select :none})

(defn quarter-option
  []
  {:display     :flex
   :gap         :8px
   :cursor      :pointer
   :font-size   :14px
   :align-items :center})

(defn simple-button
  []
  ^{:pseudo {:hover {:color        (theme/color [:button :hover :primary :color])
                     :border-color (theme/color [:button :hover :secondary :bg])
                    }}}
  ^{:media {{:screen :only :max-width (px 899)}
            {:align-self :flex-end}}}
  {:display        "inline-block"
   :padding        "16px"
   :font-size      "12px"
   :color          (theme/color [:button :regular :frame :fg])
   :letter-spacing "2.2px"
   :font-weight    "bold"
   :text-transform "uppercase"
   :border-radius  "0"
   :border-width   "1px"
   :border-style   "solid"
   :border-color   (theme/color [:button :regular :frame :fg])
   :background     (theme/color [:button :regular :secondary :fg])
   :cursor         "pointer"
   :white-space    :nowrap
   :user-select    :none})

(defn checkbox-container
  []
  {:display     "flex"
   :align-items :center
   :gap         :8px})

(defn checkbox-input
  []
  {})
